// extracted by mini-css-extract-plugin
export default {"wrapper":"PrecoAtacadoFilters_wrapper__8g2CQ","content":"PrecoAtacadoFilters_content__q0ZGh"};